export type UnderwritingStatus = 'eligible' | 'ineligible' | 'unsure' | null;

export const UNDERWRITING_STATUS_CONFIG = {
  eligible: {
    label: 'Likely Eligible',
    classes: {
      bgColor: 'bg-green-50',
      textColor: 'text-green-700',
      borderColor: 'border-green-200',
    },
  },
  unsure: {
    label: 'Review Needed',
    classes: {
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-800',
      borderColor: 'border-blue-200',
    },
  },
  ineligible: {
    label: 'Likely Ineligible',
    classes: {
      bgColor: 'bg-red-50',
      textColor: 'text-red-800',
      borderColor: 'border-red-300',
    },
  },
} as const;

export const UNDERWRITING_STATUS_FILTERS = Object.entries(UNDERWRITING_STATUS_CONFIG).map(
  ([value, config]) => ({
    value,
    label: config.label,
    classes: config.classes,
  }),
);

export const PROMPT_TYPE_TO_CARRIER_MAP: Record<string, string> = {
  'underwriting-cs-guidance': 'CareScout',
  'underwriting-nw-guidance': 'Nationwide',
  'underwriting-oa-guidance': 'OneAmerica',
};
